import React from 'react';
import PropTypes from 'prop-types';
import { TablePagination } from '@material-ui/core';
import { Flex } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../make-css';

const useCss = makeCss((theme) => ({
  pagination: {
    flex: 1,
    '& .MuiSelect-select': {
      fontSize: '14px',
      minWidth: 'unset',
    },
    '& .MuiSelect-icon': {
      top: 'unset',
      right: 0,
      transform: 'unset',
    },
  },
  paginationContainer: {
    alignItems: 'center',
    borderTop: `1px solid ${theme.palette.slate[200]}`,
  },
  rowsPerPageMenu: {
    '& .MuiTablePagination-menuItem': {
      fontSize: '14px',
    },
  },
}));

const Pagination = ({
  children,
  count,
  onPageChange,
  onRowsPerPageChange,
  page,
  rowsPerPage,
  rowsPerPageOptions,
}) => {
  const css = useCss();
  return (
    <Flex css={css.paginationContainer}>
      {children}
      <TablePagination
        component="div"
        count={count}
        css={css.pagination}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions}
        SelectProps={{ MenuProps: { css: css.rowsPerPageMenu } }}
      />
    </Flex>
  );
};

Pagination.propTypes = {
  children: PropTypes.node,
  count: PropTypes.number,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
};

export default Pagination;
